module.exports = __webpack_public_path__ + "img/iamerick.09a98b43.jpg";